import '@zr/common/js/header/_candidate_header_desktop_shared';
import '@zr/common/js/skip_to_content';
import './_search_form_desktop';
import './_search_form_submit';
import { initFiltersMenu } from './_filters_menu';
import { initNotifications } from '../_notifications';
import './_auto-complete-header';

initFiltersMenu();

// Fetch user's email and suggested jobs count. TODO: Use apiRequest instead of $.get().
if (zr.page.model.isLoggedIn) {
  initNotifications();

  // Fetch email address.
  $.get({
    url: '/api/profile',
    success(data) {
      const email = data?.data?.profile?.email_address; // eslint-disable-line camelcase

      if (email) {
        $('#myProfileEmailAddress').text(email);
      }
    },
    dataType: 'json',
    contentType: 'application/json',
    xhrFields: {
      withCredentials: true,
    },
  });
}

// Show buttons now that they have been initialized.
// $('.item_notifier, .hamburger').css('opacity', 1);
